import React from 'react';

import { IntlShape } from 'react-intl-next';

import {
  QuickInsertActionInsert,
  QuickInsertItem,
} from '@atlaskit/editor-common/provider-factory';
import { NextEditorPlugin } from '@atlaskit/editor-common/types';
import { EditorState } from '@atlaskit/editor-prosemirror/state';

import CodeSuggestionsToolbarButton from './code-suggestions-toolbar-button';
import { codeSuggestionsEditModeMessages } from './code-suggestions.i18n';
import { CodeSuggestionsIcon } from './CodeSuggestionsIcon';
import { registerEditorViewPlugin } from './pm-plugins/get-editor-view';
import { handlePMKeydownPlugin } from './pm-plugins/pm-key-handler';
import { insertCodeSuggestionNode } from './utils';

const codeSuggestionsQuickInsertItem = (intl: IntlShape): QuickInsertItem => ({
  title: intl.formatMessage(codeSuggestionsEditModeMessages.title),
  description: intl.formatMessage(codeSuggestionsEditModeMessages.description),
  priority: 100,
  keywords: ['suggestion'],
  // keyshortcut: '```suggestion', we might need this later
  icon: () => <CodeSuggestionsIcon />,
  action: (_insert: QuickInsertActionInsert, state: EditorState, _source) => {
    const { tr } = state;
    return insertCodeSuggestionNode(tr);
  },
});

export const codeSuggestionsPlugin: NextEditorPlugin<'codeSuggestions'> = ({
  api,
}) => {
  return {
    name: 'codeSuggestions',
    pmPlugins: () => [
      {
        name: 'codeSuggestionsRegisterEditorView',
        plugin: () => registerEditorViewPlugin(),
      },
      {
        name: 'codeSuggestionsFocusPlugin',
        plugin: () => handlePMKeydownPlugin(),
      },
    ],
    primaryToolbarComponent: () => {
      return <CodeSuggestionsToolbarButton api={api} />;
    },
    pluginsOptions: {
      quickInsert: (intl: IntlShape) => [codeSuggestionsQuickInsertItem(intl)],
    },
  };
};
